import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { MarkdownContent } from 'components/core/MarkdownContent';

export default function markdownToHtml(md = '') {
	if (!md || md.trim() === '') return '';

	const html = ReactDOMServer.renderToStaticMarkup(
		<MarkdownContent content={md} />
	).trim();

	// Only unwrap the outer <p> when there is exactly one paragraph block;
	// multi-paragraph content must keep its tags to stay valid HTML.
	const isSingleParagraph = /^<p>[^]*<\/p>$/.test(html) && html.indexOf('<p>', 1) === -1;
	return isSingleParagraph ? html.replace(/^<p>([^]*)<\/p>$/, '$1') : html;
}
